import React, { useEffect, useState } from "react";
import Spline from "@splinetool/react-spline";
// import HomeLogin from "./HomeLogin";
import Loading from "components/loadings/HomeLoader";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import Tnc from "components/tnc/Tnc";
import Contact from "./Contact";

const spline_lg_link =
  "https://prod.spline.design/phYXnVczKarEVsYU/scene.splinecode";
const spline_sm_link =
  "https://prod.spline.design/5QUN3jnaRczCQsq6/scene.splinecode";

export default function Spline3D() {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:500px)");

  useEffect(() => {
    const open = window.open;
    window.open = (url, target, options) => {
      if (target === "_blank") return navigate(url);

      return open(url, target, options);
    };

    return () => {
      window.open = open;
    };
  }, [navigate]);

  return (
    <div className="relative w-full h-full">
      <div className="absolute top-4 sm:top-6 left-4 sm:left-16">
        <img src="/logos/edge_white.svg" alt="" width="100" />
      </div>
      {/* <HomeLogin /> */}

      <div className="absolute bottom-2 right-2 pb-4">
        <Tnc />
      </div>

      <div className="absolute bottom-2 left-4 pb-2">
        <Contact />
      </div>

      {isMobile ? (
        <SplineComponent link={spline_sm_link} />
      ) : (
        <SplineComponent link={spline_lg_link} />
      )}
    </div>
  );
}

const SplineComponent = ({ link }) => {
  const [loading, setLoading] = useState(true);

  return (
    <>
      {loading && <Loading />}

      <div className="overflow-hidden">
        <Spline
          onLoad={() => setTimeout(() => setLoading(false), 500)}
          scene={link}
        />
      </div>
    </>
  );
};
